/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpsertChannelRequestViewModel } from "../types/UpsertChannelRequestViewModel.ts";
import { ePlayerTypeSchema } from "./ePlayerTypeSchema.ts";

export const upsertChannelRequestViewModelSchema = z.object({
  channelCode: z
    .string()
    .describe(
      "Código de incorporação do canal. Obrigatório, máximo de 4000 caracteres. Gravado verbatim, sem sanitização — a API não renderiza o conteúdo.",
    )
    .nullish(),
  channelName: z
    .string()
    .describe(
      "Nome do canal. Obrigatório, máximo de 20 caracteres — o limite real da coluna, contra os 17 que o ViewModel legado declarava.",
    )
    .nullish(),
  videoVimeoId: z
    .string()
    .describe(
      "ID do vídeo no Vimeo. Máximo de 100 caracteres. Opcional inclusive quando o player é Vimeo, porque 4.326 canais Vimeo da base não têm esse ID.",
    )
    .nullish(),
  playerType: z.optional(
    z
      .lazy(() => ePlayerTypeSchema)
      .describe("1 = Vimeo | 2 = YouTube | 3 = JWPlayer | 4 = Others | "),
  ),
  liveStreamLink: z
    .string()
    .describe(
      "Link de transmissão ao vivo. Máximo de 400 caracteres. Opcional.",
    )
    .nullish(),
  isAudio: z.optional(
    z
      .boolean()
      .describe(
        "Define se o canal é de áudio. Quando verdadeiro, a marcação de tempo do vídeo precisa vir desligada.",
      ),
  ),
  isInternational: z.optional(
    z.boolean().describe("Define se o canal é internacional."),
  ),
  isSubtitling: z.optional(
    z.boolean().describe("Define se o canal tem legendagem."),
  ),
  m3U8: z
    .string()
    .describe("Link da playlist M3U8. Máximo de 400 caracteres. Opcional.")
    .nullish(),
  downloadLinkHighDefinition: z
    .string()
    .describe(
      "Link de download em alta definição. Máximo de 400 caracteres. Opcional.",
    )
    .nullish(),
  downloadLinkStandardDefinition: z
    .string()
    .describe(
      "Link de download em definição padrão. Máximo de 400 caracteres. Opcional.",
    )
    .nullish(),
  downloadLinkLowDefinition: z
    .string()
    .describe(
      "Link de download em baixa definição. Máximo de 400 caracteres. Opcional.",
    )
    .nullish(),
  videoDuration: z
    .number()
    .int()
    .describe(
      "Duração da mídia, em minutos. Entre 0 e 999999. Opcional, e aplicável também a canal de áudio.",
    )
    .nullish(),
  recordVideoTime: z.optional(
    z
      .boolean()
      .describe(
        "Define se a posição de reprodução do aluno é registrada. Precisa ser falso quando o canal é de áudio.",
      ),
  ),
  channelDashLink: z
    .string()
    .describe(
      "Link DASH do canal. Máximo de 400 caracteres. Opcional — no legado só a geração automática preenchia este campo.",
    )
    .nullish(),
  channelDashLinkExpiration: z
    .string()
    .datetime()
    .describe(
      "Expiração do link DASH. Opcional. Gravada como informada, sem conversão de fuso — no legado cada gravação subtraía três horas do valor.",
    )
    .nullish(),
  active: z.optional(z.boolean().describe("Situação do canal.")),
}) as unknown as ToZod<UpsertChannelRequestViewModel>;
